export default __webpack_public_path__ + "static/media/STATREP - New Rochelle.42e6b76c.pdf";